<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="2"></HeaderRegion>

    <div id="mainPage">
      <div class="task-select">
        <!-- 引入输入框 -->
        <div class="task-search">
          <SearchInput ref="SearchFrom"></SearchInput>
        </div>

        <!--
          引入切换状态栏
          region用来区分页面调用,我以文件名作为区分
        -->
        <div class="task-tabbar">
          <SwitchHallTabbar ref="SwitchFrom" region="hall"></SwitchHallTabbar>
        </div>
      </div>

      <!--
        引入产品列表
        region用来区分页面调用,我以文件名作为区分
      -->
      <div class="task-productList">
        <ProductHallList ref="ProductFrom" region="hall" :pageIndex="pageIndex" :pageSize="pageSize"
                         :queryType="queryType" :val="val"></ProductHallList>
      </div>

      <!-- 引入分页器 -->
<!--      <div class="PagePagination">-->
<!--        <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize"-->
<!--                        :queryType="queryType" :val="val"></PagePagination>-->
<!--      </div>-->
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import SearchInput from "../../components/searchInput/searchInput"; //引入输入框
import SwitchHallTabbar from "../../components/switchTabbar/switchHallTabbar"; //引入切换状态栏
import ProductHallList from "../../components/productList/productHallList"; //引入产品列表
// import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器
export default {
  name: "hall",
  components: {
    HeaderRegion,
    BottomRegion,
    SearchInput,
    SwitchHallTabbar,
    ProductHallList,
    // PagePagination,
  },
  data() {
    return {
      headerForm: 1,
      pageIndex: 1,
      pageSize: 10,
      queryType: 1,
      val: '',
      total: 0
    };
  },
  created() {},
  watch: {
    val(n, o) {
      console.log(n, o)
      //this.$refs.ProductFrom.getProductList()
    }
  },
  methods: {
    //子SwitchTabbar--改变tab类型
    changeType(queryType) {
      this.queryType = queryType;
      this.pageIndex = 1;
      setTimeout(() => {
        this.$refs.ProductFrom.isTrue = true
        this.$refs.ProductFrom.getProductList()
      }, 100)
    },
    //查询
    changeVal(val) {
      this.val = val;
    },
    submitSearch(){
      setTimeout(()=>{
        this.$refs.ProductFrom.getProductList()
      },100)
    },
    changePageInfo(current, size, total) {
      this.pageIndex = current;
      this.pageSize = size;
      this.total = total
      setTimeout(() => {
        //this.$refs.ProductFrom.getProductList()
      }, 100)
    },
    changePageIndex(page) {
      this.pageIndex = page;
      setTimeout(() => {
        this.$refs.ProductFrom.getProductList()
      }, 100)
    }
  },
};
</script>


<style scoped>
  .container {
    width: 100%;
  }

  .task-search {
    padding: 28px 0 0 0;
    width: 100%;
  }

  .task-select {
    background: #ffffff;
  }

  .task-tabbar {
    margin: 36px 0 0 0;
  }

  .task-productList {
    width: 80%;
    margin: 0 10%;
  }

  .PagePagination {
    width: 63%;
    margin: 56px 18.5% 0px 18.5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/hall/hall.vue